module.exports = __webpack_public_path__ + "static/media/agendamento-icon.603d2f33.png";